export default "__VITE_ASSET__BKUWOpVH__"